
export class Image {
    Height: number;
    Src: string;
    Title: string;
    Type: string;
    Width: number;
    constructor(source: any) {
        this.Height = source.height;
        this.Src = source.src;
        this.Title = source.Title;
        this.Type = source.Type;
        this.Width = source.width;
    }
}
